import React from 'react';
import './AdditionalInfo.css';
import img from '../../img/jile4.jpg';

const AdditionalInfo = () => {
  return (
    <section className="additional-info">
      <div className="additional-info-overlay"></div>
      <div className="container">
        <div className="additional-info-content">
          <div className="additional-info-row">
            <div className="additional-info-col additional-info-text">
              {/* <div className="text-spacer-large"></div>
              <div className="text-spacer-small"></div> */}
              <div className="additional-info-description">
                <p>
                  Мы много лет работаем в гостиничном бизнесе, и в процессе развития мы организовали 
                  сеть небольших гостиниц и хостелов, расположенных как в центральной части России, 
                  так и в Республике Башкортостан и Челябинской области.
                </p>
                <br />
                <p>
                  В нашей гостинице, «Белая» Вас ждут чистые уютные номера на двоих или нескольких 
                  человек, с просторной общей кухней-гостиной, где есть все необходимое для 
                  приготовления пищи, проведения общего досуга.
                </p>
                <br />
                <p>
                  Как показала практика, формат гостевого дома, является наиболее удобным для 
                  проживания иностранцев, так как подобное взаимодействие делает совместное 
                  проживание еще более экономически выгодным.
                </p>
              </div>
            </div>
            
            <div className="additional-info-col additional-info-image">
              {/* <div className="image-spacer-large"></div> */}
              <div className="additional-info-image-container">
                <img src={img} alt="Интерьер гостиницы" />
              </div>
              {/* <div className="image-spacer-medium"></div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalInfo;